export enum DonationType {
    DirectedDonor = 1,
    StandardVoucher = 2,
    NonDirectedDonor = 3,
    FamilyVoucher = 4,
    RemoteDirect = 5,
    KflInternalDirect = 6,
    KflRemoteDirect = 7,
    Bridge = 8,
    NkrInternalDirect = 9,
    SwapSaver = 10,
    RealTimeSwapFailure = 11
}

export const DonationTypeDescription : { [key in DonationType]: string } = {
    [DonationType.DirectedDonor]: 'Paired',
    [DonationType.StandardVoucher]: 'Standard Voucher',
    [DonationType.NonDirectedDonor]: 'Non-Directed',
    [DonationType.FamilyVoucher]: 'Family Voucher',
    [DonationType.RemoteDirect]: 'Remote Direct',
    [DonationType.KflInternalDirect]: 'Kidney for Life Internal',
    [DonationType.KflRemoteDirect]: 'Kidney for Life Remote',
    [DonationType.Bridge]: 'Bridge',
    [DonationType.NkrInternalDirect]: 'NKR Internal Direct',
    [DonationType.SwapSaver]: 'Swap Saver',
    [DonationType.RealTimeSwapFailure]: 'Real-Time Swap Failure'
}

export const isVoucher = (type : DonationType) => {
    if (type == DonationType.StandardVoucher) {
        return true;
    }

    if (type == DonationType.FamilyVoucher) {
        return true;
    }

    if (type == DonationType.SwapSaver) {
        return true;
    }

    if (type == DonationType.RealTimeSwapFailure) {
        return true;
    } 

    return false;
}

export const isChainStarter = (type : DonationType) => {
    if (type == DonationType.StandardVoucher) {
        return true;
    } 

    if (type == DonationType.FamilyVoucher) {
        return true;
    }

    if (type == DonationType.RealTimeSwapFailure) {
        return true;
    }

    if (type == DonationType.NonDirectedDonor) {
        return true;
    }

    if (type == DonationType.SwapSaver) {
        return true;
    }
    
    if (type == DonationType.Bridge) {
        return true;
    } 

    return false;
}